"use strict";

exports.__esModule = true;
exports.CreateTicketUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _CreateTicketActionElement = require("./CreateTicketActionElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CreateTicketUserAction = exports.CreateTicketUserAction = {
  name: "CreateTicket",
  icon: "TicketsIcon",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "CreateTicketUserActionDefinition.label",
    defaultMessage: "Create Ticket"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "CreateTicketUserActionDefinition.description",
    defaultMessage: "Create a ticket"
  }),
  requiresContexts: ["device"],
  requiresProps: [],
  components: {
    Element: _CreateTicketActionElement.CreateTicketActionElement
  }
};